<template>
  <div class="rymbal-website">
    <Nav />
    <section id="home" class="banner">
      <div class="banner-bg">
        <video class="banner-video" autoplay loop muted playsinline preload="metadata"
          :poster="require('@/assets/placeholder.png')">
          <source :src="require('@/assets/banner.mp4')" type="video/mp4">
        </video>
      </div>
      <div class="banner-title animate-element" data-animate="slide-up">
      </div>
    </section>
    <section id="about" class="stats stats-animate">
      <div class="container">
        <h2 class="section-heading" style="text-align:center;font-size:40px;">
          SCALING NEW HEIGHTS OF SUCCESS
        </h2>
        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-icon">🏭</div>
            <p class="stat-num">50+</p>
            <p class="stat-desc">Unique Products</p>
          </div>
          <div class="stat-item">
            <div class="stat-icon">👥</div>
            <p class="stat-num">100+</p>
            <p class="stat-desc">Customers Served</p>
          </div>
          <div class="stat-item">
            <div class="stat-icon">⭐</div>
            <p class="stat-num">100+</p>
            <p class="stat-desc">Team of Experts</p>
          </div>
          <div class="stat-item">
            <div class="stat-icon">📊</div>
            <p class="stat-num">200+</p>
            <p class="stat-desc">Man-years of Expertise</p>
          </div>
          <div class="stat-item">
            <div class="stat-icon">🔬</div>
            <p class="stat-num">100,000+</p>
            <p class="stat-desc">Man-hours of R&D</p>
          </div>
        </div>
      </div>
    </section>
    <section id="products" class="products">
      <div class="container">
        <h2 class="section-heading" style="margin:10px 0 60px 0;color:#d42327;font-size:48px;text-align:center;">
          PIONEERING PRODUCTS THAT ARE<br>
          REDEFINING THE INDUSTRY
        </h2>
        <div class="products-grid">
          <div class="product-large">
            <div class="product-large-img-wrap">
              <img src="@/assets/fluidx.jpg" alt="High Quality Polyurethane Industrial Raw Material FluidX"
                class="product-img" />
              <div class="product-desc">
                <p style="width:220px;margin-bottom:35px;">Professional chemical raw materials supply for global
                  industrial manufacturing industry</p>
              </div>
            </div>
            <p class="product-name">FluidX</p>
          </div>
          <div class="product-small-grid">
            <div class="product-small">
              <img src="@/assets/biosafe.jpg" alt="Eco-friendly PVC Chemical Raw Material BioSafe"
                class="product-img" />
              <p class="product-name">BioSafe</p>
            </div>
            <div class="product-small">
              <img src="@/assets/reneu.jpg" alt="Industrial Grade EVA Sheet Raw Material ReNeu" class="product-img" />
              <p class="product-name">ReNeu</p>
            </div>
            <div class="product-small">
              <img src="@/assets/automotive-seats.jpg" alt="PU Foam Raw Material For Automotive Seats"
                class="product-img" />
              <p class="product-name">Automotive Seats</p>
            </div>
            <div class="product-small">
              <img src="@/assets/rymgrip.jpg" alt="Industrial Adhesive Chemical Raw Material RymGrip"
                class="product-img" />
              <p class="product-name">RymGrip</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="rnd" class="rnd">
      <div class="rnd-bg"></div>
      <div class="rnd-mask"></div>
      <div class="container">
        <h2 class="section-heading" style="text-align:center;font-size:40px;">
          R&D EXCELLENCE: OUR DISTINCT EDGE
        </h2>
        <div class="rnd-grid">
          <div class="rnd-item">
            <div class="rnd-icon">🏢</div>
            <p class="rnd-desc">State-of-the-art Technical Centre</p>
          </div>
          <div class="rnd-item">
            <div class="rnd-icon">👨‍🔬</div>
            <p class="rnd-desc">Experienced Team of 25+ Scientists & Researchers</p>
          </div>
          <div class="rnd-item">
            <div class="rnd-icon">🔄</div>
            <p class="rnd-desc">Agile Product Development Cycles</p>
          </div>
        </div>
      </div>
    </section>
    <section id="testimonials" class="testimonials">
      <div class="container">
        <h2 class="section-heading" style="color:#d42327;text-align:center;font-size:50px">
          OUR PARTNERS' VOICES OF TRUST
        </h2>
        <div class="testimonials-grid">
          <div class="testimonial-card">
            <p class="testimonial-quote">
              “We've been using QINYUAN's RAW MATERIAL FOR Polyurethane systems for over 10 year and the results have
              been outstanding.
              Their top-quality products have significantly boosted our production efficiency.”
            </p>
            <p class="testimonial-author" style="margin-top:75px;">HASSAN</p>
            <p class="testimonial-position">CHIEF OF PURCHASE OF CHEMISAN CO., </p>
          </div>
          <div class="testimonial-card">
            <p class="testimonial-quote">
              “As a long-time client of QINYUAN GROUP, we've always been impressed with the superior quality of their
              raw material products.
              What truly sets them apart is their thoroughness with understanding our unique requirements.”
            </p>
            <p class="testimonial-author" style="margin-top:75px;">ALI ARAB</p>
            <p class="testimonial-position">DIRECTOR OF ZARRIN POUSHESH JAM.,CO</p>
          </div>
          <div class="testimonial-card">
            <p class="testimonial-quote">
              “Partnering with QINYUAN GROUP has been an absolute game-changer for our business.
              Their speed and service in delivery product is unmatched and they consistently deliver cutting-edge
              solutions that help us improve our operational efficiency.”
            </p>
            <p class="testimonial-author">AJMAL</p>
            <p class="testimonial-position">TECHNICAL Director OF A.T.S SYNTHETIC (PVT) CO.,LTD</p>
          </div>
        </div>
      </div>
    </section>
    <section id="industries" class="industries">
      <div class="container">
        <h2 class="section-heading" v-animate="{ type: 'fadeLeft' }"
          style="color:#d42327;text-align:center;font-size:50px;margin-bottom:40px">
          INDUSTRIES WE EMPOWER
        </h2>
        <div class="carousel-wrap" @mouseenter="stopCarousel" @mouseleave="startCarousel">
          <div class="industries-carousel"
            :style="{ transform: `translateX(-${carouselOffset}%)`, transition: `transform ${animateDuration} linear` }">
            <div class="industry-item" v-for="(item, index) in carouselList" :key="index">
              <img :src="item.img" :alt="item.altText" class="industry-img" />
              <p class="industry-name">{{ item.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="partners" class="partners">
      <div class="container">
        <h2 class="section-heading" style="color:#fff;font-size:46px;text-align:center;">
          ADORNED WITH ESTEEMED ASSOCIATIONS
        </h2>
        <div class="partners-grid">
          <img src="@/assets/partner1.png" alt="Global Industry Cooperation Partner Brand Logo" class="partner-logo" />
          <img src="@/assets/partner2.png" alt="Global Industry Cooperation Partner Brand Logo" class="partner-logo" />
          <img src="@/assets/partner3.png" alt="Global Industry Cooperation Partner Brand Logo" class="partner-logo" />
          <img src="@/assets/partner4.png" alt="Global Industry Cooperation Partner Brand Logo" class="partner-logo" />
          <img src="@/assets/partner5.png" alt="Global Industry Cooperation Partner Brand Logo" class="partner-logo" />
        </div>
      </div>
    </section>
    <section id="news" class="news">
      <div class="container">
        <h2 class="section-heading" style="color:#d42327;font-size:50px;">
          WE'RE THE NEWSMAKERS
        </h2>
        <div class="news-carousel">
          <div class="carousel-track" ref="carouselTrack">
            <div class="carousel-item" v-for="(item, index) in newsList" :key="index">
              <img :src="item.img" :alt="item.altText" class="news-img" />
              <p class="news-title">{{ item.title }}</p>
            </div>
          </div>
          <button class="carousel-btn prev-btn" @click="prevSlide" v-if="currentIndex !== 0">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 19L8 12L15 5" stroke="#fff" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
          <button class="carousel-btn next-btn" @click="nextSlide">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 5L16 12L9 19" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
        <router-link to="/about" custom v-slot="{ navigate }">
          <button class="get-started-btn" @click="navigate">
            Get Started ⇨
          </button>
        </router-link>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
export default {
  directives: {
    animate: {
      bind(el, binding) {
        const { type = "fadeUp", duration = 1000 } = binding.value || {};
        el.style.opacity = 0;
        el.style.transform = "translateY(60px)";
        el.style.transition = `all ${
          duration / 1000
        }s cubic-bezier(0.25, 0.46, 0.45, 0.94)`;
        el.style.willChange = "opacity, transform";
        el.style.pointerEvents = "none";
        const triggerAnimate = () => {
          el.style.opacity = 1;
          el.style.transform = "translateY(0)";
          el.style.pointerEvents = "auto";
        };
        requestAnimationFrame(triggerAnimate);
        el._animateCleanup = () => {
          el.style.opacity = "";
          el.style.transform = "";
          el.style.transition = "";
          el.style.willChange = "";
        };
      },
      unbind(el) {
        if (el._animateCleanup) el._animateCleanup();
      },
    },
  },
  data() {
    return {
      carouselData: [
        {
          img: require("@/assets/banner.jpg"),
          name: "SYNTHETIC LEATHER",
          altText: "Synthetic Leather Industrial Chemical Raw Material",
        },
        {
          img: require("@/assets/banner.jpg"),
          name: "PU SYSTEM MATERIAL",
          altText: "PU System Industrial Raw Material Supply",
        },
        {
          img: require("@/assets/banner.jpg"),
          name: "FOOTWEAR",
          altText: "Shoe Making Industry Special Chemical Raw Materials",
        },
        {
          img: require("@/assets/banner.jpg"),
          name: "RIGID PU MATERIAL",
          altText: "High Strength Rigid PU Foam Raw Material",
        },
        {
          img: require("@/assets/banner.jpg"),
          name: "ADHESIVE",
          altText: "Industrial Environmental Protection Adhesive Raw Material",
        },
        {
          img: require("@/assets/banner.jpg"),
          name: "thermoplastic polyurethane elastomer",
          altText: "Thermoplastic Polyurethane Elastomer Industrial Material",
        },
        {
          img: require("@/assets/banner.jpg"),
          name: "SOFT PU FOAM  ",
          altText: "Comfort Soft PU Foam Raw Material",
        },
        {
          img: require("@/assets/banner.jpg"),
          name: "plasticizer",
          altText: "Industrial High Efficiency Plasticizer Chemical Material",
        },
      ],
      carouselOffset: 0,
      carouselTimer: null,
      slideSpeed: 30,
      animateDuration: "0.1s",
      step: 0.1,
      newsList: [
        {
          img: require("@/assets/banner.jpg"),
          title:
            "1Rymbal at PU Tech 2025: Mission to Redefine Material Science'",
          altText:
            "Polyurethane Industry Exhibition And Material Technology Research News",
        },
        {
          img: require("@/assets/banner.jpg"),
          title:
            "2Rymbal at PU Tech 2025: Mission to Redefine Material Science",
          altText: "Global Chemical Raw Material Industry Development News",
        },
        {
          img: require("@/assets/banner.jpg"),
          title:
            "3Rymbal at PU Tech 2025: Mission to Redefine Material Science",
          altText: "EVA PVC Industrial Material Technology Update News",
        },
        {
          img: require("@/assets/banner.jpg"),
          title:
            "4Rymbal at PU Tech 2025: Mission to Redefine Material Science",
          altText: "Chemical Raw Material Export Foreign Trade News",
        },
        {
          img: require("@/assets/banner.jpg"),
          title:
            "5Rymbal at PU Tech 2025: Mission to Redefine Material Science",
          altText: "Industrial One-stop Service Industry Dynamic News",
        },
        {
          img: require("@/assets/banner.jpg"),
          title:
            "6Rymbal at PU Tech 2025: Mission to Redefine Material Science",
          altText: "High Quality Industrial Raw Material Manufacturing News",
        },
        {
          img: require("@/assets/banner.jpg"),
          title:
            "7How Is Innovation a Sustainable Solution for Polyurethane Footwear Waste Management?",
          altText:
            "Polyurethane Material Environmental Protection And Sustainable Development Research",
        },
        {
          img: require("@/assets/banner.jpg"),
          title:
            "8How Everyday Plastics May Be Endangering Your Heart and What Sustainable Alternatives Offer",
          altText:
            "Green Environmental Protection Industrial Chemical Material Research News",
        },
      ],
      currentIndex: 0,
      isTransitioning: false,
      gap: 10,
      autoPlayTimer: null,
      autoPlayInterval: 3000,
    };
  },
  computed: {
    carouselList() {
      return [...this.carouselData, ...this.carouselData];
    },
  },
  mounted() {
    this.startCarousel();
    this.$nextTick(() => {
      this.forceAlignCarousel();
      this.startAutoPlay();
    });

    const handleScroll = () => {
      const stats = document.getElementById("about");
      if (
        stats &&
        !stats.classList.contains("show") &&
        stats.getBoundingClientRect().top < window.innerHeight - 100
      ) {
        stats.classList.add("show");
      }
      const products = document.getElementById("products");
      if (
        products &&
        !products.classList.contains("show") &&
        products.getBoundingClientRect().top < window.innerHeight - 100
      ) {
        products.classList.add("show");
      }
      const rnd = document.getElementById("rnd");
      if (
        rnd &&
        !rnd.classList.contains("show") &&
        rnd.getBoundingClientRect().top < window.innerHeight - 200
      ) {
        rnd.classList.add("show");
      }
      const testimonials = document.getElementById("testimonials");
      if (
        testimonials &&
        !testimonials.classList.contains("show") &&
        testimonials.getBoundingClientRect().top < window.innerHeight - 200
      ) {
        testimonials.classList.add("show");
      }
      const partners = document.getElementById("partners");
      if (
        partners &&
        !partners.classList.contains("show") &&
        partners.getBoundingClientRect().top < window.innerHeight - 160
      ) {
        partners.classList.add("show");
      }
      const news = document.getElementById("news");
      if (
        news &&
        !news.classList.contains("show") &&
        news.getBoundingClientRect().top < window.innerHeight - 100
      ) {
        news.classList.add("show");
        this.forceAlignCarousel();
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("scroll", handleScroll, { passive: true });
      this.stopCarousel();
      this.stopAutoPlay();
    });

    const carousel = document.querySelector(".news-carousel");
    if (carousel) {
      carousel.addEventListener("mouseenter", () => this.stopAutoPlay());
      carousel.addEventListener("mouseleave", () => this.startAutoPlay());
    }

    window.addEventListener("resize", () => {
      this.$nextTick(() => {
        this.forceAlignCarousel();
      });
    });
    document.title =
      "QINYUAN CORP | Professional Polyurethane PVC EVA Raw Material Supplier In China";
  },
  beforeUnmount() {
    this.stopCarousel();
    this.stopAutoPlay();
    window.removeEventListener("resize", this.forceAlignCarousel);
  },
  methods: {
    forceAlignCarousel() {
      const track = this.$refs.carouselTrack;
      if (!track) return;
      const items = track.querySelectorAll(".carousel-item");
      if (items.length === 0) return;
      const singleWidth = items[0].offsetWidth + this.gap;
      track.style.transition = "none";
      track.style.transform = `translateX(-${
        this.currentIndex * singleWidth
      }px)`;
      setTimeout(() => {
        track.style.transition = "transform 0.5s ease-in-out";
      }, 50);
    },

    startCarousel() {
      this.stopCarousel();
      this.carouselTimer = setInterval(() => {
        this.carouselOffset += this.step;
        if (this.carouselOffset >= 100) {
          this.carouselOffset = 0;
        }
      }, this.slideSpeed);
    },
    stopCarousel() {
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer);
        this.carouselTimer = null;
      }
    },

    startAutoPlay() {
      this.stopAutoPlay();
      this.autoPlayTimer = setInterval(() => {
        this.nextSlide();
      }, this.autoPlayInterval);
    },

    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    },

    prevSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      const track = this.$refs.carouselTrack;
      if (!track) {
        this.isTransitioning = false;
        return;
      }

      const items = track.querySelectorAll(".carousel-item");
      if (items.length === 0) {
        this.isTransitioning = false;
        return;
      }
      const singleWidth = items[0].offsetWidth + this.gap;
      const maxIndex = this.newsList.length - 4;

      this.currentIndex--;
      if (this.currentIndex < 0) {
        this.currentIndex = maxIndex;
      }
      track.style.transform = `translateX(-${
        this.currentIndex * singleWidth
      }px)`;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500);
    },

    nextSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      const track = this.$refs.carouselTrack;
      if (!track) {
        this.isTransitioning = false;
        return;
      }

      const items = track.querySelectorAll(".carousel-item");
      if (items.length === 0) {
        this.isTransitioning = false;
        return;
      }
      const singleWidth = items[0].offsetWidth + this.gap;
      const maxIndex = this.newsList.length - 4;

      this.currentIndex++;
      if (this.currentIndex > maxIndex) {
        this.currentIndex = 0;
      }
      track.style.transform = `translateX(-${
        this.currentIndex * singleWidth
      }px)`;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500);
    },
  },
};
</script>

<style scoped>
:root,
body,
.rymbal-website {
  width: 100%;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.container {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: border-box;
}
.banner {
  position: relative;
  width: 80%;
  height: 170vh;
  overflow: hidden;
  margin: 0 auto;
}
.banner-bg {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  z-index: 0;
}
.banner-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  will-change: transform;
  backface-visibility: hidden;
  transform: translateZ(0);
  pointer-events: none;
}
.banner-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  text-align: center;
  z-index: 2;
  width: 90%;
}
.banner-title h1 {
  font-size: 48px;
  font-weight: 700;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  margin: 10px 0;
}
@media (max-width: 768px) {
  .banner-title h1 {
    font-size: 24px;
  }
}
@media (min-width: 769px) and (max-width: 1200px) {
  .banner-title h1 {
    font-size: 36px;
  }
}
.stats {
  color: #fff;
  padding: 90px 0 100px 0;
  margin-top: 20px;
  opacity: 1 !important;
  visibility: hidden;
  transform: translateY(0);
  transition: visibility 0s, all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  background: url(@/assets/bg-black.png) center/cover no-repeat;
}
.stats.show {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
}
.section-heading {
  height: 90px;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 50px;
  text-transform: uppercase;
  opacity: 0;
  transform: translateY(80px);
  transition: all 0.1s cubic-bezier(0.2, 0.4, 0.25, 1);
}
.stats-grid {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;
  text-align: center;
}
.stat-item {
  flex: 1;
  min-width: 180px;
  opacity: 0;
  transform: translateY(80px);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.stat-item:nth-child(1) {
  transition-delay: 0.2s;
}
.stat-item:nth-child(2) {
  transition-delay: 0.4s;
}
.stat-item:nth-child(3) {
  transition-delay: 0.6s;
}
.stat-item:nth-child(4) {
  transition-delay: 0.8s;
}
.stat-item:nth-child(5) {
  transition-delay: 1s;
}
.stats.show .section-heading,
.stats.show .stat-item {
  opacity: 1;
  transform: translateY(0);
}
.stat-icon {
  font-size: 36px;
  margin-bottom: 15px;
  color: #e02020;
}
.stat-num {
  font-size: 32px;
  font-weight: 700;
  margin: 10px 0;
}
.stat-desc {
  font-size: 14px;
  color: #ccc;
}
.products {
  padding: 64px 0 50px 0;
  background: #fff;
}
.products-grid {
  display: grid;
  margin-top: 20px;
  grid-template-columns: 1fr 2fr;
  gap: 40px;
  align-items: start;
}
.product-large {
  display: flex;
  flex-direction: column;
  gap: 20px;
  opacity: 0;
  transform: translateX(-80px);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.1s;
  z-index: 1;
}
.product-large-img-wrap {
  position: relative;
  width: 100%;
  height: 600px;
  border-radius: 4px;
  overflow: hidden;
  transition: transform 0.3s ease;
}
.product-desc {
  position: absolute;
  left: 30px;
  bottom: 30px;
  z-index: 10;
  color: #fff;
  font-size: 16px;
  line-height: 1.6;
  font-weight: 500;
  margin: 0;
  width: 300px;
  word-wrap: break-word;
  word-break: break-word;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s;
}
.product-desc p {
  margin: 0;
  padding: 2px 0;
}
.product-small-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  height: 600px;
  align-content: space-between;
}
.product-small {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 290px;
  border-radius: 4px;
  overflow: hidden;
  opacity: 0;
  transform: translateX(80px);
}
.product-small:nth-child(1) {
  transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
}
.product-small:nth-child(2) {
  transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s;
}
.product-small:nth-child(3) {
  transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.4s;
}
.product-small:nth-child(4) {
  transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s;
}
.product-img {
  width: 100%;
  object-fit: cover;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  opacity: 0;
  transform: scale(0.75);
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.product-large-img-wrap .product-img {
  height: 100%;
  transition-delay: 0.2s;
}
.product-small .product-img {
  height: calc(100% - 44px);
}
.product-small:nth-child(1) .product-img {
  transition-delay: 0.3s;
}
.product-small:nth-child(2) .product-img {
  transition-delay: 0.4s;
}
.product-small:nth-child(3) .product-img {
  transition-delay: 0.5s;
}
.product-small:nth-child(4) .product-img {
  transition-delay: 0.6s;
}
.product-large-img-wrap:hover .product-img,
.product-small:hover .product-img {
  transform: translateY(-15px) scale(1.02);
}
.product-name {
  font-size: 20px;
  font-weight: 500;
  color: #333;
  margin: 0;
  padding-top: 4px;
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.product-large .product-name {
  transition-delay: 0.4s;
}
.product-small:nth-child(1) .product-name {
  transition-delay: 0.5s;
}
.product-small:nth-child(2) .product-name {
  transition-delay: 0.6s;
}
.product-small:nth-child(3) .product-name {
  transition-delay: 0.7s;
}
.product-small:nth-child(4) .product-name {
  transition-delay: 0.8s;
}
.section-heading {
  opacity: 0;
  transform: translateX(-80px);
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  height: auto;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 50px;
  text-transform: uppercase;
  position: relative;
  z-index: 10;
}
.products.show .section-heading,
.products.show .product-large,
.products.show .product-small,
.products.show .product-img,
.products.show .product-name,
.products.show .product-desc {
  opacity: 1;
  transform: translate(0) scale(1);
}
@media (max-width: 1440px) {
  .container {
    max-width: 1380px;
  }
  .product-large-img-wrap {
    height: 550px;
  }
  .product-small-grid {
    height: 550px;
  }
  .product-small {
    height: 260px;
  }
  .section-heading {
    font-size: 26px;
  }
  .product-name {
    font-size: 19px;
  }
}
@media (max-width: 1200px) {
  .container {
    max-width: 1140px;
  }
  .products-grid {
    gap: 30px;
  }
  .product-large-img-wrap {
    height: 500px;
  }
  .product-small-grid {
    height: 500px;
    gap: 25px;
  }
  .product-small {
    height: 240px;
  }
  .section-heading {
    font-size: 24px;
  }
  .product-desc {
    width: 280px;
    left: 25px;
    bottom: 25px;
  }
}
.rnd {
  position: relative;
  width: 100%;
  padding: 80px 0;
  /* background: url(../assets/bg-black.png) center/cover no-repeat;*/
  color: #fff;
  overflow: hidden;
}
.rnd-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  z-index: -1;
  background-image: url("@/assets/bg-black.png");
}

.rnd-grid {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  margin-top: 40px;
}
.rnd-item {
  flex: 1;
  text-align: center;
  opacity: 0;
  transform: translateY(70px);
  transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.rnd-item:nth-child(1) {
  transition-delay: 0.2s;
}
.rnd-item:nth-child(2) {
  transition-delay: 0.4s;
}
.rnd-item:nth-child(3) {
  transition-delay: 0.6s;
}
.rnd-icon {
  font-size: 36px;
  margin-bottom: 15px;
  color: #e02020;
  opacity: 0;
  transform: scale(0.7) translateY(40px);
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
}
.rnd-desc {
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.4s;
}
.rnd .section-heading {
  margin: 0;
  opacity: 0;
  transform: translateY(60px) scale(0.95);
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.rnd.show .section-heading {
  opacity: 1;
  transform: translateY(0) scale(1);
}
.rnd.show .rnd-item {
  opacity: 1;
  transform: translateY(0);
}
.rnd.show .rnd-icon {
  opacity: 1;
  transform: scale(1) translateY(0);
}
.rnd.show .rnd-desc {
  opacity: 1;
  transform: translateY(0);
}
.testimonials {
  padding: 76px 0;
  background: #f5f5f5;
  overflow: hidden;
}
.testimonials-grid {
  display: flex;
  gap: 38px;
  flex-wrap: wrap;
  margin-top: 40px;
  justify-content: center;
  width: 100%;
}
.testimonial-card {
  flex: 1;
  min-width: 300px;
  max-width: 400px;
  width: 100%;
  height: 570px;
  padding: 90px 30px 0 35px;
  background: url(@/assets/paper.png) no-repeat;
  background-size: cover;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
  opacity: 0;
  transform: translateY(90px) rotate(2deg) scale(0.9);
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.testimonial-card:nth-child(1) {
  transition-delay: 0.1s;
}
.testimonial-card:nth-child(2) {
  transition-delay: 0.2s;
}
.testimonial-card:nth-child(3) {
  transition-delay: 0.3s;
}
.testimonial-card:hover {
  transform: translateY(-8px) rotate(0deg) scale(1.02);
}
.testimonial-quote {
  font-size: 21px;
  line-height: 1.8;
  color: #4f4e4e;
  margin-bottom: 30px;
  font-style: italic;
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
}
.testimonial-author {
  font-size: 24px;
  font-weight: 700;
  color: #e02020;
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.4s;
  margin: 0;
}
.testimonial-position {
  font-size: 16px;
  color: #686767;
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.6s;
  margin: 8px 0 0;
}
.testimonials .section-heading {
  margin: 0;
  opacity: 0;
  transform: translateX(-50px) scale(0.98);
  transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.testimonials.show .section-heading {
  opacity: 1;
  transform: translateX(0) scale(1);
}
.testimonials.show .testimonial-card {
  opacity: 1;
  transform: translateY(0) rotate(0deg) scale(1);
}
.testimonials.show .testimonial-quote,
.testimonials.show .testimonial-author,
.testimonials.show .testimonial-position {
  opacity: 1;
  transform: translateY(0);
}
.industries {
  padding: 38px 0 90px 0;
  background: #fff;
}
.carousel-wrap {
  overflow: hidden;
  width: 100%;
  margin: 0 auto;
  cursor: pointer;
}
.industries-carousel {
  display: flex;
  gap: 15px;
  width: 200%;
  will-change: transform;
}
.industry-item {
  flex: 0 0 calc((100% - 60px) / 5) !important;
  text-align: center;
  box-sizing: border-box !important;
  min-width: calc((100% - 60px) / 5) !important;
}
.industry-img {
  width: 100%;
  height: 280px;
  object-fit: cover;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.industry-name {
  font-size: 18px;
  font-weight: 500;
  margin-top: 15px;
  color: #333;
}
.partners {
  padding: 60px 0;
  background: url(@/assets/bg-red.png) no-repeat center center;
  background-size: cover;
  position: relative;
  overflow: visible;
  width: 100%;
  margin-bottom: 0;
  padding-bottom: 60px;
}
.partners .section-heading {
  margin: 0 0 40px 0;
  line-height: 1.3;
  opacity: 0;
  transform: translateY(5px);
  transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;
  z-index: 10;
}
.partners-grid {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;
  padding: 0 20px;
  position: relative;
  z-index: 10;
}
.partner-logo {
  height: 220px;
  width: 220px;
  border: 5px solid #ffffff97;
  object-fit: cover;
  display: block;
  flex: 0 0 220px;
  margin: 0 auto;
  opacity: 0;
  transform: translateY(5px) scale(0.99);
  transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.partner-logo:nth-child(1) {
  transition-delay: 0.01s;
}
.partner-logo:nth-child(2) {
  transition-delay: 0.02s;
}
.partner-logo:nth-child(3) {
  transition-delay: 0.03s;
}
.partner-logo:nth-child(4) {
  transition-delay: 0.04s;
}
.partner-logo:nth-child(5) {
  transition-delay: 0.05s;
}
.partners.show .section-heading {
  opacity: 1;
  transform: translateY(0);
}
.partners.show .partner-logo {
  opacity: 1;
  transform: translateY(0) scale(1);
}
@media (max-width: 992px) {
  .partners-grid {
    justify-content: margin;
    /* justify-content: center; */
  }
  .partner-logo {
    flex: 0 0 auto;
    margin: 10px 15px;
    width: 80px;
  }
  .partners .section-heading {
    font-size: 30px;
  }
}
.news {
  padding: 60px 0 120px 0;
  background: #fff;
  text-align: center;
  overflow: hidden;
  position: relative;
}
.news .section-heading {
  font-size: 36px;
  font-weight: 700;
  color: #333;
  margin: 0 0 40px 0;
  opacity: 0;
  transform: translateX(-80px) scale(0.95);
  transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;
  z-index: 10;
}
.news-carousel {
  position: relative;
  width: 100%;
  max-width: 100%;
  margin: 60px auto 50px;
  overflow: hidden;
  opacity: 0;
  transform: translateY(70px) scale(0.9);
  transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.carousel-track {
  display: flex;
  height: 510px;
  transition: transform 0.5s ease-in-out;
  gap: 10px;
  width: fit-content;
}
.carousel-item {
  flex: 0 0 calc(25% - 7px);
  width: calc(25% - 7px);
  height: 510px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
}
.news-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.carousel-item:hover .news-img {
  transform: scale(1.08);
}
.news-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 15px;
  margin: 0;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  box-sizing: border-box;
}
.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #ef4346;
  border: 1px solid #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.3s ease;
  opacity: 1;
}
.carousel-btn:hover {
  background: #d42327;
}
.prev-btn {
  left: 20px;
}
.next-btn {
  right: 20px;
}
.news.show .section-heading {
  opacity: 1;
  transform: translateX(0) scale(1);
}
.news.show .news-carousel {
  opacity: 1;
  transform: translateY(0) scale(1);
}
::v-deep .get-started-btn {
  padding: 12px 30px;
  background: #d94a4a;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s ease;
}
::v-deep .get-started-btn:hover {
  background: #c01010;
}
::v-deep .get-started-btn:active {
  background: #a80e0e;
  transform: translateY(1px);
}
.news.show .get-started-btn {
  opacity: 1;
  transform: translateY(0) scale(1);
}
@media (max-width: 768px) {
  .carousel-item {
    flex: 0 0 calc(50% - 10px);
    width: calc(50% - 10px);
  }
  .news .section-heading {
    font-size: 28px;
  }
  .banner-title h1 {
    font-size: 32px;
  }
  .stats-grid,
  .rnd-grid,
  .testimonials-grid,
  .industries-grid {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
}
@media (max-width: 992px) {
  .products-grid {
    grid-template-columns: 1fr;
  }
}
/* 全局移动端适配新增代码 */
html {
  font-size: 16px;
}
@media screen and (max-width: 1440px) {
  html {
    font-size: 15px;
  }
}
@media screen and (max-width: 1200px) {
  html {
    font-size: 14px;
  }
}
@media screen and (max-width: 768px) {
  html {
    font-size: 13px;
  }
  .banner {
    width: 95%;
    height: 100vh;
  }
  .banner-title h1 {
    font-size: 24px;
  }
  .products-grid {
    grid-template-columns: 1fr;
  }
  .stats-grid,
  .rnd-grid,
  .testimonials-grid {
    flex-direction: column;
    align-items: center;
  }
  .carousel-item {
    flex: 0 0 calc(50% - 10px);
    width: calc(50% - 10px);
  }
}
</style>